import CheckIcon from "@mui/icons-material/Check";
import { Box, Checkbox, SvgIcon, Tooltip } from "@mui/material";
import { Switch } from "antd";
import Cookies from "js-cookie";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { USER_GROUP } from "../../../assets/data/UserGroupsData";
import NoRowOverlay from "../../../assets/images/icons/NoRowOverlay";
import { getShiftListAll } from "../../../axios/Shift/ShiftApi";
import { getUserList } from "../../../axios/User/UserApi";
import CustomSelect from "../../../components/CustomSelect";
import CustomSpinner from "../../../components/CustomSpinner";
import PrimaryDivider from "../../../components/PrimaryDivider";
import { StyledDataGrid } from "../../../components/StyledComponents";
import { useAuth } from "../../../context/AuthContext";
import CustomPagination from "../CustomPagination";
import CustomAutocomplete from "./../../../components/CustomAutocomplete";
import ReportsTabs from "./ReportsTabs";
import ReportsHub from "./ReportsHub";
import { generateTranslateMuiTable } from "../../../utils/Function/commonFunction";
import { TroubleshootOutlined } from "@mui/icons-material";
import CustomSelectShiftReport from "../../../components/CustomSelectShiftReport";
import { useLoading } from "../../../context/LoadingContext";
import DefaultTooltip from "../../../components/DefaultTooltip";
import QuestionIcon16pxSvg from "../../../assets/images/icons/QuestionIcon16pxSvg";
import { format, isValid, parse, parseISO } from "date-fns";
import { useRefresh } from "../../../context/RefreshContext";
import CustomColumnsPanel from "../../../components/CustomColumnsPanel";

const Reports = () => {
  const { refreshData } = useRefresh();
  const { t, i18n } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [gridLoading, setGridLoading] = useState(false);
  // const [selectedRows, setSelectedRows] = useState({});
  const [shiftsData, setShiftsData] = useState([]);
  const [usersData, setUsersData] = useState([]);
  const [userGroupData, setUserGroupData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowCount, setRowCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [tableData, setTableData] = useState({});
  const [tabName, setTabName] = useState("");
  const [showRejectedLeaves, setShowRejectedLeaves] = useState(false);
  const { profile, isAdmin, dateTimeFormat, genaralSettingDateFormat, genaralSettingTimeFormat, maximumLeaveDuration } = useAuth();
  // const currentLang = i18n.language;
  // const doiTen = s => s.split(' ').slice(1).join(' ') + ' ' + s.split(' ')[0];
  const tableTranslated = useMemo(() => generateTranslateMuiTable(t), [t]);
  const [hideColumns, setHideColumns] = useState(true);
  const [show, hide] = useLoading();
  // const [initialFormData, setInitialFormData] = useState([])

  const [shiftList, setShiftList] = useState([]);

  // useEffect(() => {
  //    const newShiftList = [{ shiftId: 0, shiftName: 'All shift' }, ...shiftsData];
  //    setShiftList(newShiftList);
  // }, [shiftsData]);

  const InfoIcon = (props) => (
    <SvgIcon {...props} sx={{ ml: "5px", mt: "8px" }}>
      <g clipPath="url(#clip0_275_8199)">
        <path
          d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM8.93 6.588L7.93 11.293C7.86 11.633 7.959 11.826 8.234 11.826C8.428 11.826 8.721 11.756 8.92 11.58L8.832 11.996C8.545 12.342 7.912 12.594 7.367 12.594C6.664 12.594 6.365 12.172 6.559 11.275L7.297 7.807C7.361 7.514 7.303 7.408 7.01 7.337L6.559 7.256L6.641 6.875L8.931 6.588H8.93ZM8 5.5C7.73478 5.5 7.48043 5.39464 7.29289 5.20711C7.10536 5.01957 7 4.76522 7 4.5C7 4.23478 7.10536 3.98043 7.29289 3.79289C7.48043 3.60536 7.73478 3.5 8 3.5C8.26522 3.5 8.51957 3.60536 8.70711 3.79289C8.89464 3.98043 9 4.23478 9 4.5C9 4.76522 8.89464 5.01957 8.70711 5.20711C8.51957 5.39464 8.26522 5.5 8 5.5Z"
          fill="#1F2937"
        />
      </g>
      <defs>
        <clipPath id="clip0_275_8199">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );

  function handleFilter(data) {
    setTableData(data);
  }

  function getTabName(data) {
    setTabName(data);
  }

  const handleSelectReport = (index) => {
    setTabValue(index);
    setSelectedReport(index);
    setTableData({});
    setRowData([]);
    setTabName("");
    setPage(0);
  };

  const handleBackToHub = () => {
    setSelectedReport(null);
    setTabValue(0);
    setTableData({});
    setRowData([]);
    setTabName("");
    setPage(0);
  };

  // Tour: mở report / quay về hub
  useEffect(() => {
    window.__openReport = (index = 0) => {
      flushSync(() => {
        setTabValue(index);
        setSelectedReport(index);
        setTableData({});
        setRowData([]);
        setTabName("");
        setPage(0);
      });
    };
    window.__backToReportsHub = () => {
      flushSync(() => {
        setSelectedReport(null);
        setTabValue(0);
        setTableData({});
        setRowData([]);
        setTabName("");
        setPage(0);
      });
    };
    return () => {
      delete window.__openReport;
      delete window.__backToReportsHub;
    };
  }, []);

  useEffect(() => {
    setRowData(tableData?.data?.map((e, index) => ({ ...e, id: index })) || []);
    const nextPageSize = tableData?.pagination?.pageSize || 50;
    const allowedPageSizes = [10, 20, 50, 100];
    setPageSize(
      allowedPageSizes.includes(nextPageSize) ? nextPageSize : 50
    );
    setRowCount(tableData?.pagination?.totalElements || 0);
    setTotalPages(tableData?.pagination?.totalPages || 1);
  }, [tableData]);

  const resetTableData = () => {
    // setTableData([]);
    // setRowData([]);
    // setRowCount(0);
    // setPage(20);
    // setTotalPages(1)
  };

  const fetchShiftData = async () => {
    try {
      setLoading(true);
      const response = await getShiftListAll(
        localStorage.getItem("i18nextLngId")
      );
      if (
        response.data.message === "Successful" ||
        response.data.message === "Thành công"
      ) {
        const modifiedShiftsData = [
          { shiftId: 0, shiftName: "All shift" },
          ...response.data.listShift,
        ];
        // setShiftsData(response.data.listShift);

        setShiftsData(modifiedShiftsData);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDateValue = (value, formatStr) => {
    if (!value) return "-";
    const dateObj = parseISO(value);
    if (isNaN(dateObj.getTime())) return "-";
    return format(dateObj, formatStr);
  };

  const allShiftIds = shiftsData.map((shift) => shift.shiftId);
  const initialFormData = {
    shift: allShiftIds,
    userGroup: 0,
    userName: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData(initialFormData);
  }, [shiftsData]);

  const parseUtcAndApplyLocalTZ = (dateStr) => {
    if (!dateStr) return null;

    // "2026-02-01 01:30:00" → "2026-02-01T01:30:00Z"
    const utcDate = new Date(dateStr.replace(" ", "T") + "Z");

    return utcDate;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "shift") {
      const selected = Array.isArray(value) ? value : [value];

      if (tabName === "TotalWorkHoursReport") {
        const selected = Array.isArray(value) ? value : [value];
        const allShiftIds = shiftsData
          .filter((s) => s.shiftId !== 0)
          .map((s) => s.shiftId);
        const isSelectingAll = selected.includes(0);
        const wasSelectingAll = formData.shift.includes(0);

        if (!isSelectingAll && wasSelectingAll) {
          setFormData((prev) => ({
            ...prev,
            shift: [],
          }));
          return;
        }

        if (wasSelectingAll && isSelectingAll) {
          const missingAnyChild = !allShiftIds.every((id) =>
            selected.includes(id)
          );
          if (missingAnyChild) {
            setFormData((prev) => ({
              ...prev,
              shift: selected.filter((id) => id !== 0),
            }));
            return;
          }
        }

        const hasSelectedAll = allShiftIds.every((id) => selected.includes(id));
        if (hasSelectedAll && !isSelectingAll) {
          setFormData((prev) => ({
            ...prev,
            shift: [0, ...allShiftIds],
          }));
          return;
        }

        if (isSelectingAll && !wasSelectingAll) {
          setFormData((prev) => ({
            ...prev,
            shift: [0, ...allShiftIds],
          }));
          return;
        }

        setFormData((prev) => ({
          ...prev,
          shift: selected,
        }));

      } else {
        const isSelectingAll = selected.includes(0);
        const wasSelectingAll = formData.shift.includes(0);

        if (isSelectingAll && !wasSelectingAll) {
          // ✅ Chọn All shift → thêm toàn bộ shiftId + 0, nhưng loại trùng
          const allIds = [...new Set([0, ...shiftsData.map((s) => s.shiftId)])];
          setFormData((prev) => ({
            ...prev,
            shift: allIds,
          }));
        } else if (!isSelectingAll && wasSelectingAll) {
          // ✅ Bỏ chọn All shift
          setFormData((prev) => ({
            ...prev,
            shift: [],
          }));
        } else if (wasSelectingAll && isSelectingAll) {
          // ✅ Đang giữ All shift, chọn lại => reset
          setFormData((prev) => ({
            ...prev,
            shift: [],
          }));
        } else if (!wasSelectingAll && !isSelectingAll) {
          if (formData.shift.length === 0) {
            setFormData((prev) => ({
              ...prev,
              shift: [selected[selected.length - 1]],
            }));
          } else if (selected.length === 1) {
            setFormData((prev) => ({
              ...prev,
              shift: selected,
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              shift: [selected[selected.length - 1]],
            }));
          }
        }

        // const isSelectingAll = selected.includes(0);
        // const wasSelectingAll = formData.shift.includes(0);
        // if (isSelectingAll && !wasSelectingAll) {
        //    const allIds = [0, ...shiftsData.map(s => s.shiftId)];
        //    setFormData(prev => ({
        //       ...prev,
        //       shift: allIds
        //    }));
        // } else if (!isSelectingAll && wasSelectingAll) {
        //    setFormData(prev => ({
        //       ...prev,
        //       shift: []
        //    }));
        // } else if (wasSelectingAll && isSelectingAll) {
        //    setFormData(prev => ({
        //       ...prev,
        //       shift: []
        //    }));
        // } else if (!wasSelectingAll && !isSelectingAll) {
        //    if (formData.shift.length === 0) {
        //       setFormData(prev => ({
        //          ...prev,
        //          shift: [selected[selected.length - 1]]
        //       }));
        //    } else if (selected.length === 1) {
        //       setFormData(prev => ({
        //          ...prev,
        //          shift: selected
        //       }));
        //    } else {
        //       setFormData(prev => ({
        //          ...prev,
        //          shift: [selected[selected.length - 1]]
        //       }));
        //    }
        // }
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleDataChange = (name, newData) => {
    let updatedValue;
    switch (name) {
      case "userName":
        updatedValue = newData?.userId || "";
        break;
      default:
        updatedValue = newData;
        break;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue,
    }));
  };

  const fetchUserData = async () => {
    try {
      setLoading(true);
      const payload = {
        statusId: 1,
        page: 1,
        pageSize: 500,
        status: null,
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await getUserList(payload);
      // const response = await getUserListAll();
      if (
        response.data.message === "Successful" ||
        response.data.message === "Thành công"
      ) {
        setUsersData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      if (error.response) {
        if (error.response.status !== 401) {
          toast.error(t(error?.response.data));
        }
      } else {
        toast.error(t('common.network-timeout'));
      }
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    const timeoutId = setTimeout(() => {
      fetchShiftData();
      fetchUserData();
      setUserGroupData(USER_GROUP);
      setLoading(false);
    }, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  const [expandedRows, setExpandedRows] = useState([]);
  const groupedData = useRef({
    current: rowData.reduce((acc, row) => {
      if (!acc[row.employeeCode]) {
        acc[row.employeeCode] = [row];
      } else {
        acc[row.employeeCode].push(row);
      }
      return acc;
    }, {}),
  });
  useEffect(() => {
    if (tabName === "TotalWorkHoursReportbkkk") {
      const data = rowData.reduce((acc, row) => {
        if (!acc[row.employeeCode]) {
          acc[row.employeeCode] = [row];
        } else {
          acc[row.employeeCode].push(row);
        }
        return acc;
      }, {});
      groupedData.current = data;
      setExpandedRows(
        Object.keys(data).map((e, index) => ({
          employeeCodeId: e,
          count: data[e].length,
          id: index,
          isExpanded: false,
        }))
      );
      return;
    }
    setExpandedRows(rowData);
  }, [rowData]);

  const toggleExpand = (employeeCodeId, isExpanded) => {
    setExpandedRows((prevRows) => {
      if (isExpanded) {
        return prevRows
          .filter((e) => e.employeeCode !== employeeCodeId)
          .map((e) =>
            e.employeeCodeId === employeeCodeId
              ? { ...e, isExpanded: false }
              : e
          );
      }

      const addItem = groupedData.current[employeeCodeId].map((e, index) => ({
        ...e,
        id: employeeCodeId + index,
      }));

      const newRows = [...prevRows];
      const insertIndex =
        newRows.findIndex((e) => e.employeeCodeId === employeeCodeId) + 1;
      newRows.splice(insertIndex, 0, ...addItem);
      return newRows.map((e) =>
        e.employeeCodeId === employeeCodeId ? { ...e, isExpanded: true } : e
      );
    });
  };

  const dateColumns = useMemo(() => {
    if (tabName !== "WorkHourSummaryReport") return [];

    const allKeys = new Set();
    if (rowData.length > 0) {
      rowData.forEach((item) =>
        Object.keys(item).forEach((key) => allKeys.add(key))
      );
    }

    // Hàm dùng chung để format 1 chuỗi ngày theo setting
    const formatWithSetting = (str) => {
      if (!str) return str;

      let parsed;

      // TH1: dd/MM/yyyy
      parsed = parse(str, "dd/MM/yyyy", new Date());
      if (isValid(parsed)) {
        return format(parsed, genaralSettingDateFormat);
      }

      // TH2: yyyy-MM-dd
      parsed = parse(str, "yyyy-MM-dd", new Date());
      if (isValid(parsed)) {
        return format(parsed, genaralSettingDateFormat);
      }

      // Fallback: ISO string
      const parsedIso = new Date(str);
      if (isValid(parsedIso)) {
        return format(parsedIso, genaralSettingDateFormat);
      }

      // Không parse được thì trả nguyên
      return str;
    };

    return [...allKeys]
      .filter((key) => {
        return (
          /^\d{4}-\d{2}-\d{2}$/.test(key) || // yyyy-mm-dd
          /^\d{4}-\d{2}-\d{2} .. \d{4}-\d{2}-\d{2}$/.test(key) || // yyyy-mm-dd .. yyyy-mm-dd
          /^[A-Za-z]+ \d{4}$/.test(key) // April 2025
        );
      })
      .map((dateKey) => {
        let header = dateKey;

        // Dải ngày: yyyy-mm-dd .. yyyy-mm-dd
        if (/^\d{4}-\d{2}-\d{2} .. \d{4}-\d{2}-\d{2}$/.test(dateKey)) {
          const [startDate, endDate] = dateKey.split(" .. ");
          header = `${formatWithSetting(startDate)} .. ${formatWithSetting(
            endDate
          )}`;
        }
        // Một ngày: yyyy-mm-dd
        else if (/^\d{4}-\d{2}-\d{2}$/.test(dateKey)) {
          header = formatWithSetting(dateKey);

        } else if (/^[A-Za-z]+ \d{4}$/.test(dateKey)) {
          const [monthEng, year] = dateKey.split(" ");
          const monthKey = monthEng.toLowerCase(); // "april"
          const monthLabel = t(`months.${monthKey}`);
          header = `${monthLabel} ${year}`;
        }

        return {
          field: dateKey,
          headerName: header,
          minWidth: 150,
          flex: 1,
          hideable: true,
          valueFormatter: (value) => {
            if (!value) return "-";
            const str = String(value).trim();
            const formatted = formatWithSetting(str);
            return formatted || "-";
          },
        };
      });
  }, [rowData, tabName, genaralSettingDateFormat, t]);

  const lateArrivalCount = useMemo(() => {
    return rowData.filter(
      (row) =>
        row.lateArrival &&
        row.lateArrival !== "-" &&
        row.lateArrival !== "00:00:00" &&
        row.lateArrival !== null
    ).length;
  }, [rowData]);

  const earlyDepartureCount = useMemo(() => {
    return rowData.filter(
      (row) =>
        row.earlyDeparture &&
        row.earlyDeparture !== "-" &&
        row.earlyDeparture !== "00:00:00" &&
        row.earlyDeparture !== null
    ).length;
  }, [rowData]);

  const isCountableTimeValue = (value) =>
    value != null &&
    value !== "-" &&
    value !== "00:00:00" &&
    String(value).trim() !== "";

  /** HH:mm / HH:mm:ss → giây; không hợp lệ thì 0 */
  const parseTimeToSeconds = (value) => {
    if (value == null || value === "" || value === "-") return 0;
    const parts = String(value).trim().split(":").map(Number);
    if (!parts.length || parts.some((n) => !Number.isFinite(n))) return 0;
    const [h = 0, m = 0, s = 0] = parts;
    return h * 3600 + m * 60 + s;
  };

  /**
   * Chỉ đổi giao diện theo showTime; dữ liệu gốc vẫn HH:mm:ss để check vi phạm.
   * h-m-s → HH:mm:ss | h-m → HH:mm | h → HH
   */
  const formatTimeByShowTime = (value, showTime = "h-m-s") => {
    if (value == null || value === "" || value === "-") return "-";
    const str = String(value).trim();
    if (!str.includes(":")) return str;

    const parts = str.split(":");
    const h = parts[0] ?? "00";
    const m = parts[1] ?? "00";
    const s = parts[2] ?? "00";

    if (showTime === "h") return h.padStart(2, "0");
    if (showTime === "h-m") return `${h.padStart(2, "0")}:${m.padStart(2, "0")}`;
    return `${h.padStart(2, "0")}:${m.padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  };

  const reportShowTime = tableData?.showTime || "h-m-s";
  const reportSumBy = tableData?.sumBy || "1";
  const isAggregatedReport = reportSumBy !== "1";

  const isLeaveUnExcusedViolation = (totalLeaveUnExcused) => {
    const maxSeconds = parseTimeToSeconds(maximumLeaveDuration);
    if (maxSeconds <= 0) return false;
    const actualSeconds = parseTimeToSeconds(totalLeaveUnExcused);
    return actualSeconds > maxSeconds;
  };

  const totalLeaveCount = useMemo(() => {
    return rowData.filter((row) => isCountableTimeValue(row.totalLeave)).length;
  }, [rowData]);

  const totalLeaveUnExcusedCount = useMemo(() => {
    return rowData.filter((row) =>
      isCountableTimeValue(row.totalLeaveUnExcused)
    ).length;
  }, [rowData]);

  const totalViolationCount = useMemo(() => {
    return rowData.reduce(
      (sum, row) => sum + (Number(row.violationCount) || 0),
      0
    );
  }, [rowData]);

  const [columnData, setColumnData] = useState([]);
  useEffect(() => {
    if (tabName === "TotalWorkHoursReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (_value, row) => {
            const fullName = row?.fullName || "";
            const email = row?.email || "";
            return `${fullName}\n${email}`;
          },
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.employee-info")}</span>
              <DefaultTooltip
                title={t("common.employee-info")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-employee-info")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          renderCell: (params) => {
            const raw = params?.value != null ? String(params.value) : "";
            const [name, email] = raw.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name || "-"}</div>
                <div>{email || ""}</div>
              </Box>
            );
          },
        },
        {
          field: "from",
          headerName: t("common.start-date"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.start-date")}</span>
              <DefaultTooltip
                title={t("common.start-date")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-start-date")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.from}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, genaralSettingDateFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, genaralSettingDateFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "to",
          headerName: t("common.end-date"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.end-date")}</span>
              <DefaultTooltip
                title={t("common.end-date")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-end-date")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.to}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, genaralSettingDateFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, genaralSettingDateFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "productiveWorkHours",
          headerName: t("common.productiveWorkHours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.productiveWorkHours")}</span>
              <DefaultTooltip
                title={t("common.productiveWorkHours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-productive-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.productiveWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
        },
        {
          field: "totalWorkHours",
          headerName: t("common.total-work-hours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.total-work-hours")}</span>
              <DefaultTooltip
                title={t("common.total-work-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
        },
        {
          field: "totalShiftWorkHours",
          headerName: t("common.totalShiftWorkHours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.totalShiftWorkHours")}</span>
              <DefaultTooltip
                title={t("common.totalShiftWorkHours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-shift-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalShiftWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
          // valueGetter: (params) => params.row.totalShiftWorkHours || '-'
        },
        {
          field: "productiveHours",
          headerName: t("common.productive-hours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.productive-hours")}</span>
              <DefaultTooltip
                title={t("common.productive-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-productive-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.productiveHours}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
          // valueGetter: (params) => params.row.productiveHours || '-'
        },
        {
          field: "totalLeave",
          headerName: t("common.totalLeave"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.totalLeave")}</span>
              <Box>({totalLeaveCount})</Box>
              <DefaultTooltip
                title={t("common.totalLeave")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-leave")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalLeave}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
          // valueGetter: (params) => params.row.totalLeave || '-'
        },
        {
          field: "totalLeaveUnExcused",
          headerName: t("common.totalNoLeave"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.totalNoLeave")}</span>
              <Box>({totalLeaveUnExcusedCount})</Box>
              <DefaultTooltip
                title={t("common.totalNoLeave")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-totalNoLeave")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalLeaveUnExcused}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
          // valueGetter: (params) => params.row.totalLeave || '-'
        },
        {
          field: "totalHoliday",
          headerName: t("common.totalHoliday"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.totalHoliday")}</span>
              <DefaultTooltip
                title={t("common.totalHoliday")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-holiday")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalHoliday}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
          // valueGetter: (params) => params.row.totalHoliday || '-'
        },
        {
          field: "leaveUnExcusedViolation",
          headerName: t("common.violation"),
          minWidth: 140,
          flex: 1,
          hideable: true,
          sortable: false,
          // Mỗi dòng một ô riêng, không gom rowSpan
          rowSpanValueGetter: (_value, row) =>
            row ? `${row.id}-leaveUnExcusedViolation` : _value,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.violation")}</span>
              {totalViolationCount > 0 && (
                <Box>({totalViolationCount})</Box>
              )}
              <DefaultTooltip
                title={t("common.violation")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-leave-unexcused-violation")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          valueGetter: (_value, row) => {
            const count = Number(row?.violationCount);
            if (Number.isFinite(count)) {
              return count > 0 ? count : 0;
            }
            return isLeaveUnExcusedViolation(row?.totalLeaveUnExcused) ? 1 : 0;
          },
          renderCell: (params) => {
            const count = Number(
              params?.row?.violationCount ??
                (isLeaveUnExcusedViolation(params?.row?.totalLeaveUnExcused)
                  ? 1
                  : 0)
            );
            if (!count || count <= 0) {
              return <Box>-</Box>;
            }

            // Daily: "Vi phạm"; Weekly/Monthly/Custom: "Vi phạm (N)" vì đã gộp nhiều ngày
            const label = isAggregatedReport
              ? t("common.violation-count", { count })
              : t("common.violation");

            return (
              <Box
                sx={{
                  color: "#D00D00",
                  fontWeight: 600,
                }}
              >
                {label}
              </Box>
            );
          },
        },
        // {
        //   field: "totalMiddleBreakTime",
        //   headerName: t("common.totalMiddleBreakTime"),
        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span style={{ fontWeight: 600 }}>{t("common.totalMiddleBreakTime")}</span>
        //       <DefaultTooltip
        //         title={t("common.totalMiddleBreakTime")}
        //         readMore={false}
        //         content={
        //           <div className="flex flex-col gap-3">
        //             <p>{t("common.report-total-middle-break-time")}.</p>
        //           </div>
        //         }
        //       >
        //         <div>
        //           <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
        //         </div>
        //       </DefaultTooltip>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.totalMiddleBreakTime}` : value,
        //   valueFormatter: (value) => {
        //     return value === null || value === undefined ? "-" : `${value}`;
        //   },
        // },
        // {
        //   field: "lateArrival",
        //   headerName: t("common.late-arrival"),
        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span style={{ fontWeight: 600 }}>{t("common.late-arrival")}</span>
        //       <Box
        //       >
        //         ({lateArrivalCount})
        //       </Box>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.lateArrival}` : value,
        //   valueFormatter: (value) => {
        //     if (value === null) {
        //       return "-";
        //     }
        //     return `${value}`;
        //   },
        // },
        // {
        //   field: "earlyDeparture",
        //   headerName: t("common.early-departure"),
        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span style={{ fontWeight: 600 }}>{t("common.early-departure")}</span>
        //       <Box
        //       >
        //         ({earlyDepartureCount})
        //       </Box>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.earlyDeparture}` : value,
        //   valueFormatter: (value) => {
        //     return value === null || value === undefined ? "-" : `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.totalHoliday || '-'
        // },
      ]);
    } else if (tabName === "WorkHourSummaryReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (params, row) => {
            const name = row.name || "";
            const email = row.email || "";
            const fullName = row.fullName || "";

            return `${fullName}\n${email}`;
          },
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.employee-info")}</span>
              <DefaultTooltip
                title={t("common.employee-info")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-employee-info")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          renderCell: (params) => {
            const [name, email] = params.value.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name}</div>
                <div>{email}</div>
              </Box>
            );
          },
        },
        {
          field: "totalProductiveWorkHours",
          headerName: t("common.total-work-hours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.total-work-hours")}</span>
              <DefaultTooltip
                title={t("common.total-work-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalWorkHours}` : value,
          valueFormatter: (value) => {
            return value == null ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.totalWorkHours || '-'
        },
      ]);
    } else if (tabName === "ProductivityReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (params, row) => {

            const fullName = row.fullName || "";
            const email = row.email || "";
            return `${fullName}\n${email}`;
          },
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.employee-info")}</span>
              <DefaultTooltip
                title={t("common.employee-info")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-employee-info")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          renderCell: (params) => {
            const [name, email] = params.value.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name}</div>
                <div>{email}</div>
              </Box>
            );
          },
        },
        {
          field: "from",
          headerName: t("common.start-date"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.start-date")}</span>
              <DefaultTooltip
                title={t("common.start-date")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-start-date")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.from}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, genaralSettingDateFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, genaralSettingDateFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "to",
          headerName: t("common.end-date"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.end-date")}</span>
              <DefaultTooltip
                title={t("common.end-date")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-end-date")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.from}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, genaralSettingDateFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, genaralSettingDateFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "productiveWorkHours",
          headerName: t("common.productive-work-hours"),
          minWidth: 200,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.productive-work-hours")}</span>
              <DefaultTooltip
                title={t("common.productive-work-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-productive-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.productiveWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null) {
              return "-";
            }
            return `${value}`;
          },
          // valueGetter: (params) => params.row.productiveWorkHours || '-'
        },
        {
          field: "overtimeWorkHours",
          headerName: t("common.overtime-work-hours"),

          minWidth: 200,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.overtime-work-hours")}</span>
              <DefaultTooltip
                title={t("common.overtime-work-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-overtime-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.overtimeWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null) {
              return "-";
            }
            return `${value}`;
          },
          // valueGetter: (params) => params.row.overtimeWorkHours || '-'
        },
        {
          field: "totalWorkHours",
          headerName: t("common.total-work-hours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.total-work-hours")}</span>
              <DefaultTooltip
                title={t("common.total-work-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-total-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalWorkHours}` : value,
          valueFormatter: (value) => {
            if (value === null) {
              return "-";
            }
            return `${value}`;
          },
          // valueGetter: (params) => params.row.totalWorkHours || '-'
        },
        {
          field: "productiveHours",
          headerName: t("common.productive-hours"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.productive-hours")}</span>
              <DefaultTooltip
                title={t("common.productive-hours")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-productive-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.productiveHours}` : value,
          valueFormatter: (value) => {
            if (value === null) {
              return "-";
            }
            return `${value}`;
          },
          // valueGetter: (params) => params.row.productiveHours || '-'
        },
        {
          field: "totalLeaveUnExcused",
          headerName: t("common.totalNoLeave"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.totalNoLeave")}</span>
              <DefaultTooltip
                title={t("common.totalNoLeave")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.totalNoLeave")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalLeaveUnExcused}` : value,
          valueFormatter: (value) => {
            if (value === null) {
              return "-";
            }
            return `${value}`;
          },
          // valueGetter: (params) => params.row.earlyArrival || '-'
        },
        // {
        //   field: "lateArrival",
        //   headerName: t("common.late-arrival"),

        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span>{t("common.late-arrival")}</span>
        //       <Box
        //       >
        //         ({lateArrivalCount})
        //       </Box>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.lateArrival}` : value,
        //   valueFormatter: (value) => {
        //     if (value === null) {
        //       return "-";
        //     }
        //     return `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.lateArrival || '-'
        // },
        // {
        //   field: "earlyDeparture",
        //   headerName: t("common.early-departure"),

        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span>{t("common.early-departure")}</span>
        //       <Box
        //       >
        //         ({earlyDepartureCount})
        //       </Box>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.earlyDeparture}` : value,
        //   valueFormatter: (value) => {
        //     if (value === null) {
        //       return "-";
        //     }
        //     return `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.earlyDeparture || '-'
        // },
        // {
        //   field: "lateDeparture",
        //   headerName: t("common.late-departure"),

        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span>{t("common.late-departure")}</span>
        //       <DefaultTooltip
        //         title={t("common.late-departure")}
        //         readMore={false}
        //         content={
        //           <div className="flex flex-col gap-3">
        //             <p>{t("common.report-late-departure")}.</p>
        //           </div>
        //         }
        //       >
        //         <div>
        //           <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
        //         </div>
        //       </DefaultTooltip>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.lateDeparture}` : value,
        //   valueFormatter: (value) => {
        //     if (value === null) {
        //       return "-";
        //     }
        //     return `${value}`;
        //   },

        //   // valueGetter: (params) => params.row.lateDeparture || '-'
        // },
        // {
        //   field: "unProductiveHours",
        //   headerName: t("common.un-productive-hours"),

        //   minWidth: 200,
        //   flex: 1,
        //   hideable: true,
        //   renderHeader: () => (
        //     <Box display="flex" alignItems="center" gap={1}>
        //       <span>{t("common.un-productive-hours")}</span>
        //       <DefaultTooltip
        //         title={t("common.un-productive-hours")}
        //         readMore={false}
        //         content={
        //           <div className="flex flex-col gap-3">
        //             <p>{t("common.report-un-productive-hours")}.</p>
        //           </div>
        //         }
        //       >
        //         <div>
        //           <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
        //         </div>
        //       </DefaultTooltip>
        //     </Box>
        //   ),
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.unProductiveHours}` : value,
        //   valueFormatter: (value) => {
        //     if (value === null) {
        //       return "-";
        //     }
        //     return `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.unProductiveHours || '-'
        // },
      ]);
    } else if (tabName === "UserDetailsReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (params, row) => {

            const email = row.email || "";
            const fullName = row.fullName || "";

            return `${fullName}\n${email}`;
          },
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>{t("common.employee-info")}</span>
              <DefaultTooltip
                title={t("common.employee-info")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-employee-info")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          renderCell: (params) => {
            const [name, email] = params.value.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name}</div>
                <div>{email}</div>
              </Box>
            );
          },
        },
        {
          field: "phone",
          headerName: t("common.phone"),
          minWidth: 200,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.phone}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined || value === ""
              ? "-"
              : `${value}`;
          },
        },
        {
          field: "addressLine1",
          headerName: t("common.address-line-1"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.addressLine1}` : value,
          valueFormatter: (value) => {
            return value === null ? "-" : `${value}`;
          },
          renderCell: (params) => {
            const text =
              params.value == null || params.value === ""
                ? "-"
                : String(params.value);
            return (
              <Tooltip
                title={text !== "-" ? text : ""}
                arrow
                placement="top"
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      lineHeight: 1.4,
                      textAlign: "center",
                    }}
                  >
                    {text}
                  </Box>
                </Box>
              </Tooltip>
            );
          },
        },
        {
          field: "addressLine2",
          headerName: t("common.address-line-2"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.addressLine2}` : value,
          valueFormatter: (value) => {
            return value === null ? "-" : `${value}`;
          },
          renderCell: (params) => {
            const text =
              params.value == null || params.value === ""
                ? "-"
                : String(params.value);
            return (
              <Tooltip
                title={text !== "-" ? text : ""}
                arrow
                placement="top"
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      lineHeight: 1.4,
                      textAlign: "center",
                    }}
                  >
                    {text}
                  </Box>
                </Box>
              </Tooltip>
            );
          },
          // valueGetter: (params) => params.row.addressLine2 || '-'
        },
        {
          field: "city",
          headerName: t("common.city"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.city}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.city || '-'
        },
        {
          field: "country",
          headerName: t("common.country"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.country}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.country || '-'
        },
        {
          field: "state",
          headerName: t("common.state"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.state}` : value,
          valueFormatter: (value) =>
            value === null || value === undefined || value === ""
              ? "-"
              : value,
        },
        {
          field: "zipCode",
          headerName: t("common.zipCode"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.zipCode}` : value,
          valueFormatter: (value) =>
            value === null || value === undefined || value === ""
              ? "-"
              : value,
        },
        {
          field: "active",
          headerName: t("button.active"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.status}` : value,
          // valueFormatter: ({ value, row }) => row?.status || '-',
          valueFormatter: (params) => params?.row?.status ?? "-",
          renderCell: (params) => (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center", // Căn giữa theo chiều dọc
                width: "100%",
                height: "100%", // Đảm bảo chiếm đủ chiều cao cell
              }}
            >
              {params.row.status === "ACTIVE" ? (
                <CheckIcon style={{ color: "green" }} />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  style={{ display: "block" }}
                >
                  <g clipPath="url(#clip0_186_35589)">
                    <path
                      d="M8.98195 1.56601C8.88296 1.39358 8.74022 1.25031 8.56815 1.15069C8.39608 1.05106 8.20078 0.998596 8.00195 0.998596C7.80312 0.998596 7.60781 1.05106 7.43574 1.15069C7.26367 1.25031 7.12094 1.39358 7.02195 1.56601L0.164946 13.233C-0.292054 14.011 0.255946 15 1.14495 15H14.8579C15.7469 15 16.2959 14.01 15.8379 13.233L8.98195 1.56601ZM7.99995 5.00001C8.53495 5.00001 8.95395 5.46201 8.89995 5.99501L8.54995 9.50201C8.53819 9.63978 8.47515 9.76813 8.3733 9.86165C8.27145 9.95517 8.13822 10.0071 7.99995 10.0071C7.86167 10.0071 7.72844 9.95517 7.62659 9.86165C7.52474 9.76813 7.46171 9.63978 7.44995 9.50201L7.09995 5.99501C7.08738 5.86925 7.10129 5.74224 7.14079 5.62218C7.18029 5.50212 7.2445 5.39166 7.32929 5.29792C7.41408 5.20419 7.51756 5.12925 7.63307 5.07794C7.74858 5.02663 7.87355 5.00008 7.99995 5.00001ZM8.00195 11C8.26716 11 8.52152 11.1054 8.70905 11.2929C8.89659 11.4804 9.00195 11.7348 9.00195 12C9.00195 12.2652 8.89659 12.5196 8.70905 12.7071C8.52152 12.8947 8.26716 13 8.00195 13C7.73673 13 7.48238 12.8947 7.29484 12.7071C7.1073 12.5196 7.00195 12.2652 7.00195 12C7.00195 11.7348 7.1073 11.4804 7.29484 11.2929C7.48238 11.1054 7.73673 11 8.00195 11Z"
                      fill="#A1A1AA"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_186_35589">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              )}
            </Box>
          ),
        },
        {
          field: "createAt",
          headerName: t("common.created-at"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>
                {t("common.created-at")}
              </span>
              <DefaultTooltip
                title={t("common.created-at")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.created-at")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.createAt}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // tách date và time
            const [datePart, timePart] = str.split(" ");
            if (!datePart || !timePart) return str;

            const [day, month, year] = datePart.split("/").map(Number);
            const [hour, minute, second] = timePart.split(":").map(Number);

            // tạo Date theo UTC
            const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));

            // format -> JS tự convert sang timezone máy
            return format(utcDate, dateTimeFormat);
          }
        },
        // {
        //   field: "createAt",
        //   headerName: t("common.created-at"),
        //   minWidth: 180,
        //   flex: 1,
        //   hideable: true,
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.createAt}` : value,
        //   valueFormatter: (value) => {
        //     return value === null ? "-" : `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.createdAt || '-'
        // },
        {
          field: "groupNames",
          headerName: t("common.groupMember"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.groupMember}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.groupMember || '-'
        },
      ]);
    } else if (tabName === "EventDetailsReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (params, row) => {
            const email = row.email || "";
            const fullName = row.fullName || "";
            return `${fullName}\n${email}`;
          },
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>
                {t("common.employee-info")}
              </span>
              <DefaultTooltip
                title={t("common.employee-info")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-employee-info")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          renderCell: (params) => {
            const [name, email] = params.value.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name}</div>
                <div>{email}</div>
              </Box>
            );
          },
        },
        // {
        //    field: 'employeeCode',
        //    headerName: t('common.employee-code'),
        //    minWidth: 180,
        //    flex: 1,
        //    hideable: true,
        //    valueFormatter: (value) => {
        //       return `${value}`;
        //    },
        //    rowSpanValueGetter: (params, row) => row.employeeCode || '-',
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        //    // valueGetter: (params) => params.row.employeeCode || '-'
        // },
        // {
        //    field: 'name',
        //    headerName: t('common.fullname'),
        //    minWidth: 180,
        //    flex: 1,
        //    hideable: true,
        //    valueGetter: (params, row) => {
        //       const firstName = row.firstName || '';
        //       const lastName = row.lastName || '';
        //       return currentLang !== 'vi' ? `${firstName} ${lastName}` : `${lastName} ${firstName}`;
        //    },
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        //    // valueGetter: (params) => {
        //    //    const firstName = params.row.firstName || '';
        //    //    const lastName = params.row.lastName || '';
        //    //    return firstName || lastName ? `${firstName} ${lastName}`.trim() : '-';
        //    // }
        // },
        // {
        //    field: 'email',
        //    headerName: t('common.email'),
        //    minWidth: 200,
        //    flex: 1,
        //    hideable: true,
        //    valueGetter: (params, row) => row.email || '-',
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        //    // valueGetter: (params) => params.row.email || '-'
        // },
        {
          field: "shiftName",
          headerName: t("common.shiftName"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.shiftName}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";

            const str = String(value).trim().toUpperCase();

            if (str === "DEFAULT") {
              return t("common.default");
            }

            return value;
          },
          // valueGetter: (params) => params.row.shiftName || '-'
        },

        {
          field: "eventType",
          headerName: t("common.eventType"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.eventType}` : value,
          valueFormatter: (value) => {
            if (value === "CHECK_IN") return "IN";
            if (value === "CHECK_OUT") return "OUT";
            return "-";
          },
          renderCell: (params) => {
            const isCheckIn = params.value === "CHECK_IN";
            const isCheckOut = params.value === "CHECK_OUT";
            return (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                  gap: 1,
                }}
              >
                <Switch
                  checked={isCheckIn}
                  style={{ backgroundColor: isCheckIn ? "#16A34A" : "#2563EB" }}
                />
                <span
                  style={{
                    color: isCheckIn ? "#16A34A" : "#2563EB",
                    fontWeight: 500,
                  }}
                >
                  {isCheckIn
                    ? t("common.in").toUpperCase()
                    : isCheckOut
                      ? t("common.out").toUpperCase()
                      : "-"}
                </span>
              </Box>
            );
          },
        },
        {
          field: "eventLogStatus",
          headerName: t("common.event-log-status"),
          minWidth: 260,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.eventLogStatus}` : value,
          valueFormatter: (value) => value || "-",
          renderCell: (params) => {
            const isValid = params.value === "VALID";
            return (
              <span style={{ color: isValid ? "#16A34A" : "#2563EB" }}>
                {params.value === "VALID"
                  ? t("common.valid")
                  : params.value === "MISSING_CHECK_OUT"
                    ? t("common.missing-check-out")
                    : t("common.missing-check-in")}
              </span>
            );
          },
        },

        {
          field: "dateTime",
          headerName: t("common.date"),
          minWidth: 180,
          flex: 1,
          valueGetter: (params) => {
            return params ?? null;
          },
          valueFormatter: (params) => {
            const result = formatDateValue(params, genaralSettingDateFormat);
            return result;
          },
        },
        {
          field: "timeOnly",
          headerName: t("common.content-036"),
          minWidth: 120,
          flex: 1,
          valueGetter: (value, row) => {
            return row?.dateTime ?? value ?? null;
          },

          // valueFormatter sẽ nhận được giá trị từ valueGetter
          valueFormatter: (params) => {
            const inputValue = params;
            if (!inputValue) return "-";
            const dateObj = parseISO(inputValue);
            if (isNaN(dateObj.getTime())) return "-";
            const result = format(dateObj, genaralSettingTimeFormat);
            return result;
          },
        },
        {
          field: "latitude",
          headerName: t("common.latitude"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.latitude}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.latitude || '-'
        },
        {
          field: "longitude",
          headerName: t("common.longitude"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.longitude}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.longitude || '-'
        },
        {
          field: "deviceRemark",
          headerName: t("common.device"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.deviceRemark}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.deviceRemark || '-'
        },
      ]);
    } else if (tabName === "ArrivalAndDepartureReport") {
      setColumnData([
        {
          field: "name",
          headerName: t("common.employee-info"),
          minWidth: 250,
          flex: 1,
          hideable: true,
          align: "left",
          valueGetter: (params, row) => {

            const fullName = row.fullName || "";
            const email = row.email || "";

            return `${fullName}\n${email}`;
          },
          //   renderHeader: () => (
          //   <Box display="flex" alignItems="center" gap={1}>
          //     <span>{t("common.employee-info")}</span>
          //     <DefaultTooltip
          //       title={t("common.employee-info")}
          //       readMore={false}
          //       content={
          //         <div className="flex flex-col gap-3">
          //           <p>{t("common.report-employee-info")}.</p>
          //         </div>
          //       }
          //     >
          //       <div>
          //         <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
          //       </div>
          //     </DefaultTooltip>
          //   </Box>
          // ),
          renderCell: (params) => {
            const [name, email] = params.value.split("\n");
            return (
              <Box
                sx={{
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                  lineHeight: 1.8,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  py: 0.25,
                }}
              >
                <div>{name}</div>
                <div>{email}</div>
              </Box>
            );
          },
        },
        // {
        //    field: 'employeeCode',
        //    headerName: t('common.employee-code'),
        //    minWidth: 180,
        //    flex: 1,
        //    hideable: true,
        //    valueFormatter: (value) => {
        //       return `${value}`;
        //    },
        //    rowSpanValueGetter: (params, row) => row.employeeCode || '-',
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        // },
        // {
        //    field: 'name',
        //    headerName: t('common.fullname'),
        //    minWidth: 180,
        //    flex: 1,
        //    hideable: true,
        //    valueGetter: (params, row) => {
        //       const firstName = row.firstName || '';
        //       const lastName = row.lastName || '';
        //       return currentLang !== 'vi' ? `${firstName} ${lastName}` : `${lastName} ${firstName}`;
        //    },
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        // },
        // {
        //    field: 'email',
        //    headerName: t('common.email'),
        //    minWidth: 200,
        //    flex: 1,
        //    hideable: true,
        //    valueGetter: (params, row) => row.email || '-',
        //    renderCell: (params) => (
        //       <Box
        //          sx={{
        //             display: 'flex',
        //             alignItems: 'center',
        //             height: '100%',
        //          }}
        //       >
        //          {params.value}
        //       </Box>
        //    )
        // },
        {
          field: "date",
          headerName: t("common.date"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.from}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, genaralSettingDateFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, genaralSettingDateFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "availability",
          headerName: t("common.availability"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.availability}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";

            const str = String(value).trim().toUpperCase();

            if (str === "NO SCHEDULE ITEMS") {
              return t("common.no-schedule-items");
            }

            if (str === "ON LEAVE") {
              return t("common.onleave");
            }

            if (str === "ABSENT") {
              return t("common.absent");
            }

            if (str === "PRESENT") {
              return t("common.present");
            }

            return value;
          },
        },
        {
          field: "shiftName",
          headerName: t("common.shiftName"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.shiftName}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";

            const str = String(value).trim().toUpperCase();

            if (str === "DEFAULT") {
              return t("common.default");
            }

            return value;
          },
        },
        {
          field: "shiftStart",
          headerName: t("common.shift-start"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.shiftStart}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const date = parseUtcAndApplyLocalTZ(value);

            return format(
              date,
              dateTimeFormat || "dd/MM/yyyy HH:mm:ss"
            );
          },
        },
        {
          field: "shiftEnd",
          headerName: t("common.shift-end"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.shiftEnd}` : value,
          valueFormatter: (value) => {
            if (!value) return "-";

            const date = parseUtcAndApplyLocalTZ(value);

            return format(
              date,
              dateTimeFormat || "dd/MM/yyyy HH:mm:ss"
            );
          },
        },

        {
          field: "fistCheckedIn",
          headerName: t("common.first-checked-in"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.firstCheckIn}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";

            return value
              ? format(new Date(value), dateTimeFormat || "dd/MM/yyyy HH:mm:ss")
              : "";
          },
        },
        {
          field: "earlyArrival",
          headerName: t("common.early-arrival"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.earlyArrival}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "lateArrival",
          headerName: t("common.late-arrival"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.lateArrival}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "lastCheckOut",
          headerName: t("common.last-checked-out"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.lastCheckOut}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "earlyDeparture",
          headerName: t("common.early-departure"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.earlyDeparture}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "lateDeparture",
          headerName: t("common.late-departure"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.lateDeparture}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "eventLog",
          headerName: t("drawer.event-log"),

          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.eventLog}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "totalWorkHours",
          headerName: t("common.total-work-hours"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.totalWorkHours}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
      ]);
    } else {
      setColumnData([
        {
          field: "remark",
          headerName: t("common.description"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.remark}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.remark || '-'
        },
        {
          field: "deviceSN",
          headerName: t("common.device-code"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.deviceSN}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.deviceSN || '-'
        },

        {
          field: "operatingSystem ",
          headerName: t("common.operating-system"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.operatingSystem}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.operatingSystem || '-'
        },
        {
          field: "osVersion",
          headerName: t("common.os-version"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.osVersion}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.osVersion || '-'
        },

        {
          field: "application",
          headerName: t("common.application"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.application}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.application || '-'
        },
        {
          field: "groupName",
          headerName: t("common.group-name"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.groupName}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.groupName || '-'
        },
        {
          field: "employeeCode",
          headerName: t("common.employee-code"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.employeeCode}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.employeeCode || '-'
        },

        // {
        //   field: "createAt",
        //   headerName: t("common.create-at"),
        //   minWidth: 200,
        //   flex: 1,
        //   hideable: true,
        //   rowSpanValueGetter: (value, row) =>
        //     row ? `${row.id}-${row.createAt}` : value,
        //   valueFormatter: (value) => {
        //     return value === null || value === undefined ? "-" : `${value}`;
        //   },
        //   // valueGetter: (params) => params.row.createAt || '-'
        // },
        {
          field: "createAt",
          headerName: t("common.created-at"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span style={{ fontWeight: 600 }}>
                {t("common.created-at")}
              </span>
              <DefaultTooltip
                title={t("common.created-at")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.created-at")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.createAt}` : value,
          valueFormatter: (value) => {
            if (!value) return "-W";

            const str = String(value).trim();

            // API trả "24/11/2025" -> parse theo pattern
            const parsed = parse(str, "dd/MM/yyyy", new Date());

            if (isValid(parsed)) {
              return format(parsed, dateTimeFormat); // hoặc dateTimeFormat bạn đang dùng
            }

            // fallback: nếu sau này backend trả ISO "2025-11-24"
            const parsedIso = new Date(str);
            if (isValid(parsedIso)) {
              return format(parsedIso, dateTimeFormat);
            }

            // nếu parse không được thì trả lại raw
            return str;
          },
        },
        {
          field: "updatedAt",
          headerName: t("common.update-at"),
          minWidth: 200,
          flex: 1,
          hideable: true,
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.updatedAt}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
          // valueGetter: (params) => params.row.updatedAt || '-'
        },
      ]);
    }
  }, [tabName, rowData, earlyDepartureCount, lateArrivalCount, totalLeaveCount, totalLeaveUnExcusedCount, totalViolationCount, maximumLeaveDuration, t, genaralSettingDateFormat, reportShowTime, isAggregatedReport]);

  // const finalColumns = useMemo(() => {
  //    const sortedDateColumns = [...dateColumns].sort((a, b) => {
  //       const dateA = new Date(a.field);
  //       const dateB = new Date(b.field);
  //       return dateA - dateB;
  //    });

  //    const index = columnData.findIndex(col => col.field === 'name');
  //    if (index === -1) return [...columnData, ...sortedDateColumns];

  //    return [
  //       ...columnData.slice(0, index + 1),
  //       ...sortedDateColumns,
  //       ...columnData.slice(index + 1)
  //    ];
  // }, [columnData, dateColumns]);
  // const [hideCl, setHideCl ] = useState(true)
  useEffect(() => {
    setHideColumns((formData.shift?.length ?? 0) < 2);
  }, [formData.shift]);

  const finalColumns = useMemo(() => {
    const sortedDateColumns = [...dateColumns].sort((a, b) => {
      const dateA = new Date(a.field);
      const dateB = new Date(b.field);
      return dateA - dateB;
    });

    let baseColumns = [...columnData];
    // workDate/workTime chỉ có ý nghĩa với Daily (nhiều dòng theo ngày/ca)
    if (tabName === "TotalWorkHoursReport" && hideColumns && !isAggregatedReport) {
      const toIndex = baseColumns.findIndex((col) => col.field === "to");

      const additionalColumns = [
        {
          field: "workDate",
          headerName: t("common.workDate"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.workDate")}</span>
              <DefaultTooltip
                title={t("common.workDate")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-work-date")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.workDate}` : value,
          valueFormatter: (value) => {
            return value === null || value === undefined ? "-" : `${value}`;
          },
        },
        {
          field: "workTime",
          headerName: t("common.workTime"),
          minWidth: 180,
          flex: 1,
          hideable: true,
          renderHeader: () => (
            <Box display="flex" alignItems="center" gap={1}>
              <span>{t("common.workTime")}</span>
              <DefaultTooltip
                title={t("common.workTime")}
                readMore={false}
                content={
                  <div className="flex flex-col gap-3">
                    <p>{t("common.report-work-hours")}.</p>
                  </div>
                }
              >
                <div>
                  <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                </div>
              </DefaultTooltip>
            </Box>
          ),
          rowSpanValueGetter: (value, row) =>
            row ? `${row.id}-${row.workTime}` : value,
          valueFormatter: (value) => {
            if (value === null || value === undefined) return "-";
            return formatTimeByShowTime(value, reportShowTime);
          },
        },
      ];

      if (toIndex !== -1) {
        baseColumns = [
          ...baseColumns.slice(0, toIndex + 1),
          ...additionalColumns,
          ...baseColumns.slice(toIndex + 1),
        ];
      } else {
        baseColumns = [...baseColumns, ...additionalColumns];
      }
    }

    // Chèn dateColumns sau cột "name" như ban đầu
    const nameIndex = baseColumns.findIndex((col) => col.field === "name");
    if (nameIndex === -1) return [...baseColumns, ...sortedDateColumns];

    return [
      ...baseColumns.slice(0, nameIndex + 1),
      ...sortedDateColumns,
      ...baseColumns.slice(nameIndex + 1),
    ];
  }, [columnData, dateColumns, tabName, hideColumns, loading, reportShowTime, isAggregatedReport]);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

  useEffect(() => {
    let visibility = {};

    switch (tabName) {
      case "TotalWorkHoursReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          from: true,
          to: true,
          workDate: true,
          workTime: true,
          productiveWorkHours: true,
          totalWorkHours: true,
          totalShiftWorkHours: true,
          productiveHours: true,
          totalLeave: true,
          totalLeaveUnExcused: true,
          totalHoliday: true,
          leaveUnExcusedViolation: true,
          totalMiddleBreakTime: true,
        };
        break;

      case "WorkHourSummaryReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          totalWorkHours: true,
        };
        break;

      case "ProductivityReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          from: true,
          to: true,
          productiveWorkHours: true,
          overtimeWorkHours: true,
          totalWorkHours: true,
          productiveHours: true,
          earlyArrival: true,
          lateArrival: true,
          earlyDeparture: true,
          lateDeparture: true,
          unProductiveHours: true,
        };
        break;

      case "UserDetailsReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          deletePerson: true,
          phone: true,
          addressLine1: true,
          addressLine2: true,
          city: true,
          country: true,
          state: true,
          zipCode: true,
          active: true,
          createAt: true,
          groupMember: true,
        };
        break;

      case "EventDetailsReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          shiftName: true,
          eventType: true,
          eventLogStatus: true,
          date: true,
          time: true,
          timeZone: true,
          latitude: true,
          longitude: true,
          deviceRemark: true,
        };
        break;

      case "ArrivalAndDepartureReport":
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          date: true,
          availability: true,
          shiftName: true,
          shiftStart: true,
          shiftEnd: true,
          fistCheckedIn: true,
          earlyArrival: true,
          lateArrival: true,
          lastCheckOut: true,
          earlyDeparture: true,
          lateDeparture: true,
          eventLog: true,
          totalWorkHours: true,
        };
        break;
      case "DeviceReport":
        visibility = {
          remark: true,
          deviceSN: true,
          operatingSystem: true,
          osVersion: true,
          application: true,
          groupName: true,
          employeeCode: true,
          createAt: true,
          updatedAt: true,
        };
        break;

      default:
        visibility = {
          // employeeCode: true,
          name: true,
          // email: true,
          active: true,
        };
        break;
    }

    setColumnVisibilityModel(visibility);
  }, [tabName]);

  const emailUser = profile?.email;
  const handleColumnVisibilityChange = (newModel) => {
    setColumnVisibilityModel(newModel);
    Cookies.set(`Report_${tabName}_${emailUser}`, JSON.stringify(newModel), {
      expires: 90,
      path: "/",
    });
  };

  useEffect(() => {
    if (!emailUser || !tabName) return;

    const saved = Cookies.get(`Report_${tabName}_${emailUser}`);
    if (saved) {
      setColumnVisibilityModel(JSON.parse(saved));
    }
  }, [emailUser, tabName]);

  useEffect(() => {
    show();
    const timeoutId = setTimeout(() => {
      hide();
    }, 3000);
  }, [refreshData, tabName]);

  const handleRowsPerPageChange = (newPageSize) => {
    // newPageSize ở đây tuỳ CustomPagination, có thể là event hoặc number
    const size =
      typeof newPageSize === "number"
        ? newPageSize
        : parseInt(newPageSize?.target?.value, 10);

    if (!Number.isFinite(size) || size <= 0) return;

    setPage((prevPage) => {
      // index của record đầu tiên đang xem
      const firstRowIndex = prevPage * pageSize;

      // page mới sao cho vẫn chứa record đó
      const newPage = Math.floor(firstRowIndex / size);

      // phòng trường hợp vượt quá số trang
      const maxPage = Math.max(
        0,
        Math.ceil(rowCount / size) - 1
      );

      return Math.min(newPage, maxPage);
    });

    setPageSize(size);
  };



  return (
    <div className="reports">
      {selectedReport === null ? (
        <ReportsHub onSelectReport={handleSelectReport} />
      ) : (
        <div className="grid grid-cols-12 gap-x-5 gap-y-5">
          <div className="col-span-12">
            <div className="card px-3 py-[1px]">
              <ReportsTabs
                tabValue={tabValue}
                onBack={handleBackToHub}
                setLoading={setLoading}
                handleFilter={handleFilter}
                dataFilter={formData}
                page={page}
                pageSize={pageSize}
                getTabName={getTabName}
                resetTableData={resetTableData}
                profile={profile}
                isAdmin={isAdmin}
                totalPages={totalPages}
              />

              {[
                "TotalWorkHoursReport",
                "WorkHourSummaryReport",
                "ProductivityReport",
                "EventDetailsReport",
                "ArrivalAndDepartureReport",
              ].includes(tabName) ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
                  {isAdmin && (
                    <CustomAutocomplete
                      className="w-full"
                      name="userName"
                      onDataChange={handleDataChange}
                      value={formData.userId}
                      options={usersData}
                      dataType="user"
                      freeSolo={true}
                      placeholder={t("common.content-161")}
                    />
                  )}
                  <CustomSelectShiftReport
                    multiple={true}
                    className={`w-full overflow-hidden whitespace-nowrap text-ellipsis ${!isAdmin ? "md:col-span-2" : ""}`}
                    name="shift"
                    value={formData.shift}
                    onChange={handleInputChange}
                    options={shiftsData}
                    dataType="shift"
                  />
                </div>
              ) : tabName === "UserDetailsReport" ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
                  {isAdmin && (
                    <CustomAutocomplete
                      className="w-full"
                      name="userName"
                      onDataChange={handleDataChange}
                      value={formData.userId}
                      options={usersData}
                      dataType="user"
                      freeSolo={true}
                      placeholder={t("common.content-161")}
                    />
                  )}
                  <div className="flex gap-2 items-center pointer-events-none opacity-50">
                    <Checkbox
                      id="rejectedLeaves"
                      className="!p-0 !ml-[-3px]"
                      checked={showRejectedLeaves}
                      onChange={() => setShowRejectedLeaves(!showRejectedLeaves)}
                    />
                    <p>{t("common.show-deleted-users")}</p>
                  </div>
                </div>
              ) : null}
              <div className="my-3">
                <PrimaryDivider />
              </div>
              <div className="min-h-0 overflow-hidden pb-2" data-tour="reports-table">
                {showSpinner && <CustomSpinner loading={true} />}
                <StyledDataGrid
                  autoHeight={false}
                  sx={{
                    height: tabName === "UserDetailsReport" ? "67vh" : "61vh",
                    overflow: "hidden", // chặn tràn ra body
                    ".MuiDataGrid-main": {
                      height: tabName === "UserDetailsReport" ? "67vh" : "61vh",
                    },

                    /* Không chừa chỗ cho scrollbar */
                    "& .MuiDataGrid-scrollbarFiller": {
                      display: "none !important",
                    },
                    "& .MuiDataGrid-columnHeaders": { paddingRight: 0 },
                    "& .MuiDataGrid-topContainer": { paddingRight: 0 },
                    "&": { "--DataGrid-scrollbarSize": "0px" },

                    /* Ẩn scrollbar giả của MUI */
                    "& .MuiDataGrid-scrollbar--vertical, & .MuiDataGrid-scrollbar--horizontal":
                    {
                      display: "none !important",
                    },

                    /* Native scrollbar: ẩn mặc định, chỉ hiện khi hover/focus */
                    "& .MuiDataGrid-virtualScroller": { scrollbarWidth: "none" },
                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                      width: 0,
                      height: 0,
                    },
                    "&:hover .MuiDataGrid-virtualScroller, &:focus-within .MuiDataGrid-virtualScroller":
                    {
                      scrollbarWidth: "thin",
                    },
                    "&:hover .MuiDataGrid-virtualScroller::-webkit-scrollbar, &:focus-within .MuiDataGrid-virtualScroller::-webkit-scrollbar":
                    {
                      width: 10,
                      height: 10,
                    },

                    /* Ẩn thanh ngang nếu có */
                    '& [class*="MuiDataGrid-scrollbar"][class*="--horizontal"]': {
                      display: "none !important",
                    },
                  }}
                  // disableColumnMenu

                  rows={expandedRows}
                  getRowClassName={(params) =>
                    params.row._isSubRow ? "sub-row" : ""
                  }
                  rowHeight={56}
                  columns={finalColumns}
                  unstable_rowSpanning={true}
                  paginationMode="client"
                  pageSize={pageSize}
                  page={page}
                  rowCount={rowCount}
                  totalPages={totalPages}
                  onPageChange={(newPage) => setPage(newPage)}
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  slots={{
                    // toolbar: CustomToolbar,
                    pagination: CustomPagination,
                    // loadingOverlay: LinearProgress,
                    noRowsOverlay: NoRowOverlay,
                    columnsPanel: CustomColumnsPanel,
                  }}
                  slotProps={{
                    //     toolbar: {
                    //         showQuickFilter: true,
                    //     },
                    //     // loadingOverlay: {
                    //     //   variant: 'linear-progress',
                    //     //   noRowsVariant: 'skeleton',
                    //     // },
                    // noRowsOverlay: {
                    //    title: "No data",
                    // },
                    pagination: {
                      page,
                      count: rowCount,
                      rowsPerPage: pageSize,
                      onPageChange: setPage,
                      onRowsPerPageChange: handleRowsPerPageChange,
                    },
                  }}
                  // onRowDoubleClick={handleRowDoubleClick}
                  // onRowSelectionModelChange={onRowsSelectionHandler}
                  localeText={tableTranslated}
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={handleColumnVisibilityChange}
                  initialState={{
                    filter: {
                      filterModel: {
                        items: [],
                        quickFilterValues: [""],
                      },
                    },
                  }}
                />
              </div>
            </div>

          </div>
        </div>
      )}

      {/* {loading && <CustomSpinner loading={loading} />} */}
    </div>
  );
};

export default Reports;
